const setCookieValue = (userId) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const expiryDate = new Date(year + 1, month, day);
  document.cookie = `UserCookie=id=${userId}; expires=${expiryDate.toUTCString()};path=/; httponly; secure`;
};
const getCookieValue = () => {
  const cookies = document.cookie.toString().split(';');
  let cookie;
  let arr = [];
  for (let i = 0; i < cookies.length; i++) { /* eslint-disable-line no-plusplus */
    cookie = cookies[i].toString().match(new RegExp('UserCookie', 'gi'));
    if (cookie !== null) {
      arr = cookies[i].split('=');
      return arr[2];
    }
  }
  return '';
};

const getLoggedInStatus = () => {
  if (getCookieValue() !== '') {
    return true;
  }
  return false;
};

const getUserId = () => (
  parseInt(getCookieValue(), 10)
);

// Retrieve digital user id for use in Usabilla survey
const getDigitalUserId = () => {
  const { sessionStorage, userId } = window;
  const digitalUserStr = sessionStorage.getItem('bali_userId');
  let digitalUserId = userId;
  if (digitalUserStr) {
    digitalUserId = JSON.parse(digitalUserStr).userId;
  }
  if (isNaN(digitalUserId)) { /* eslint-disable-line no-restricted-globals */
    digitalUserId = '';
  }
  return digitalUserId;
};

export {
  getDigitalUserId,
  getLoggedInStatus,
  getUserId,
  setCookieValue,
};
